import * as api from "./api";

export const GET_ALL_ORGANIZATION = "mangnifi/marker/GET_ALL_ORGANIZATION";
export const GET_ORGANIZATION_COUNT = "magnifi/organization/GET_ORGANIZATION_COUNT";
export const CREATE_ORGANIZATION = "magnifi/organization/CREATE_ORGANIZATION";
export const CREATE_ORGANIZATION_WORKSPACE = "magnifi/organization/CREATE_ORGANIZATION_WORKSPACE";
export const GET_ALL_ORGANIZATION_WORKSPACES = "magnifi/organization/GET_ALL_ORGANIZATION_WORKSPACES";
export const CREATE_ORGANIZATION_USER = "magnifi/organization/CREATE_ORGANIZATION_USER";
export const GET_ORGANIZATIONS = "magnifi/organization/GET_ORGANIZATIONS";
export const EDIT_ORGANIZATION = "magnifi/organization/EDIT_ORGANIZATION";
export const GET_ORGANIZATION_ASSIGNABLE_USERS = "magnifi/organization/GET_ORGANIZATION_ASSIGNABLE_USERS";
export const ASSIGN_ORGANIZATION_USER = "magnifi/organization/ASSIGN_ORGANIZATION_USER";
export const DELETE_ORGANIZATION = "magnifi/organization/DELETE_ORGANIZATION";
export const GET_ORGANIZATION_WORKSPACES = "magnifi/organization/GET_ORGANIZATION_WORKSPACES";
export const GET_ORGANIZATION_USERS = "magnifi/organization/GET_ORGANIZATION_USERS";
export const UPDATE_ORGANIZATION_MEMBER = "magnifi/organization/UPDATE_ORGANIZATION_MEMBER";
export const GET_ORGANIZATION_DETAILS = "magnifi/organization/GET_ORGANIZATION_DETAILS";
export const DOWNLOAD_ORGANIZATION_CSV = "magnifi/organization/DOWNLOAD_ORGANIZATION_CSV";
/*
export const getAllOrganization = (limit, pageNo, search) => {
  return {
    type: GET_ALL_ORGANIZATION,
    payload: api.getAllOrganization(limit, pageNo, search),
  };
};
*/

export const getOrganizationsCount = () => {
  return {
    type: GET_ORGANIZATION_COUNT,
    payload: api.getOrganizationsCount(),
  };
};

export const createOrganization = (data) => {
  return {
    type: CREATE_ORGANIZATION,
    payload: api.createOrganization(data),
  };
};

export const getAllOrganizations = () => {
  return {
    type: GET_ALL_ORGANIZATION,
    payload: api.getAllOrganizations(),
  };
};

export const createOrganizationWorkspace = (data) => {
  return {
    type: CREATE_ORGANIZATION_WORKSPACE,
    payload: api.createOrganizationWorkspace(data),
  };
};

export const getAllOrganizationWorkspaces = (data) => {
  return {
    type: GET_ALL_ORGANIZATION_WORKSPACES,
    payload: api.getAllOrganizationWorkspaces(data),
  };
};

export const createOrganizationUser = (data) => {
  return {
    type: CREATE_ORGANIZATION_USER,
    payload: api.createOrganizationUser(data),
  };
};

export const getOrganizations = (data) => {
  return {
    type: GET_ORGANIZATIONS,
    payload: api.getOrganizations(data),
  };
};

export const editOrganization = (data) => {
  return {
    type: EDIT_ORGANIZATION,
    payload: api.editOrganization(data),
  };
};

export const getOrganizationAssignableUsers = (data) => {
  return {
    type: GET_ORGANIZATION_ASSIGNABLE_USERS,
    payload: api.getOrganizationAssignableUsers(data),
  };
};

export const assignOrganizationUser = (data) => {
  return {
    type: ASSIGN_ORGANIZATION_USER,
    payload: api.assignOrganizationUser(data),
  };
};

export const deleteOrganization = (data) => {
  return {
    type: DELETE_ORGANIZATION,
    payload: api.deleteOrganization(data),
  };
};

export const getOrganizationWorkspaces = (data) => {
  return {
    type: GET_ORGANIZATION_WORKSPACES,
    payload: api.getOrganizationWorkspaces(data),
  };
};

export const getOrganizationUsers = (data) => {
  return {
    type: GET_ORGANIZATION_USERS,
    payload: api.getOrganizationUsers(data),
  };
};

export const getOrganizationDetails = (data) => {
  return {
    type: GET_ORGANIZATION_DETAILS,
    payload: api.getOrganizationDetails(data),
  };
};

export const downloadOrganizationCSV = (data) => {
  return {
    type: DOWNLOAD_ORGANIZATION_CSV,
    payload: api.downloadOrganizationCSV(data),
  };
};
